module.exports = __webpack_public_path__ + "img/download-play-store.29af4eb4.jpeg";